export default function navantaPermissions() {
  return {
    template: require('./navanta-permissions.html'),
    restrict: 'E',
    replace: true,
    scope: {
      expanded: '=',
      userRoles: '=',
    },
  };
}
